var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-image',{attrs:{"config":_vm.frameImageConfig}}),_c('v-sprite',{ref:"frameEffects",attrs:{"config":_vm.frameSpriteConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }